module.exports = __webpack_public_path__ + "static/about-0d3a46bf9ccd3d224caf80200a4f1a3c.jpg";